import { render, staticRenderFns } from "./editAgree.vue?vue&type=template&id=d70ced50&scoped=true"
import script from "./editAgree.vue?vue&type=script&lang=js"
export * from "./editAgree.vue?vue&type=script&lang=js"
import style0 from "./editAgree.vue?vue&type=style&index=0&id=d70ced50&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d70ced50",
  null
  
)

export default component.exports